import { create } from 'zustand';
import { CashTx } from '../types/CashTx';
import cashTxAPI from '../api/cashTxAPI';
import { devtools } from 'zustand/middleware';
import constants from '../constants';

type actionType = 'approve' | 'reject';

export interface CreateCashTxType {
  requestType: 'deposit' | 'withdrawal';
  userId: string;
  amount: number;
  reason: string;
  accountBank?: string;
  accountName?: string;
  accountNumber?: string;
	reasonCode?: string;
}

interface CashTxState {
  isLoading: boolean;
  cashTxs: CashTx[] | [];
  allUserCashTotal: number;
	firstBaljuTotal: number;
	testUserTotal: number;
	setCashTxs: (cashTxs: CashTx[]) => void;
  fetchCashTxs: ({ page, userId, status }: {page: number, userId?: string, status?: string}) => Promise<void>;
  fetchAllUserCashTotal: () => Promise<void>;
  updateCashTx: ({ id, cashTxDTO, action }: { id: string, cashTxDTO: CashTx | null, action: actionType }) => Promise<void>;
  createCashTx: (value: CreateCashTxType) => Promise<void>;
}

const approveOrRejectCashTx = async ({ id, cashTxDTO, action }: { id: string, cashTxDTO: CashTx | null, action: actionType }): Promise<CashTx> => {
  return action === 'approve'
    ? await cashTxAPI.confirmCashRequestAPI(id, cashTxDTO)
    : await cashTxAPI.rejectCashRequestAPI(id, cashTxDTO);
};

const cashTxStore = create<CashTxState>()(
  devtools((set,  get) => ({
    cashTxs: [],
    allUserCashTotal: 0,
	  firstBaljuTotal: 0,
	  testUserTotal: 0,
    isLoading: true,
	  setCashTxs: (cashTxs: CashTx[]) => {
			set({ cashTxs });
	  },
    createCashTx: async (cashTx: CreateCashTxType) => {
      if (cashTx.requestType === 'deposit') {
        await cashTxAPI.createDepositRequestAPI(cashTx);
      } else if (cashTx.requestType === 'withdrawal') {
        await cashTxAPI.createWithdrawRequestAPI(cashTx);
      }
    },
    updateCashTx: async ({ id, cashTxDTO, action }: { id: string, cashTxDTO: CashTx | null, action: actionType }) => {
      const updatedCashTx = await approveOrRejectCashTx({ id, cashTxDTO, action });
      set({ cashTxs: get().cashTxs.map(tx => tx.id === id ? updatedCashTx : tx) });
    },
    fetchCashTxs: async ({ page, userId, status }: {page: number, userId?: string, status?: string}) => {
      set({ isLoading: true });
      try {
        const cashTxs = await cashTxAPI.fetchCashRequestAPI({
	        page,
	        userId,
	        status,
	        limit: constants.PAGE_SIZE,
        });
        console.log('fetched user cash txs:', cashTxs);
        set({ cashTxs });
      } catch (error) {
        set({ cashTxs: [] });
      } finally {
        set({ isLoading: false });
      }
    },
    fetchAllUserCashTotal: async () => {
      const { allUserCashTotal, firstBaljuTotal, testUserTotal } = await cashTxAPI.fetchAllUserCashTotalAPI();
      set({ allUserCashTotal, firstBaljuTotal, testUserTotal });
    }
    })
  )
);

export default cashTxStore;
